module.exports = __webpack_public_path__ + "img/decrement.f71c6ade.svg";